import API from '../config/config';  // Fix the import path
import axios from 'axios';

// Create a separate axios instance for admin requests
const adminAxios = axios.create({
  baseURL: API.BASE_URL
});

// Add auth token interceptor
adminAxios.interceptors.request.use(
  (config) => {
    const adminToken = localStorage.getItem('adminToken');
    if (adminToken) {
      config.headers.Authorization = `Bearer ${adminToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Handle token expiration
adminAxios.interceptors.response.use(
  (response) => response,
  (error) => {

    
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('adminToken');
      localStorage.removeItem('admin');
      window.location.href = '/admin/login';
    }
    return Promise.reject(error);
  }
);

// Test connection to API
export const testApiConnection = async () => {
  try {
    const response = await axios.get(`${API.BASE_URL}/api/test`);
    return response.data;
  } catch (error) {
    console.error("API Test Error:", error);
    throw error;
  }
};

/**
 * Login admin user
 * @param {string} email - Admin email
 * @param {string} password - Admin password
 * @returns {Promise<Object>} Login result with token and admin data
 */
export const loginAdmin = async (email, password) => {
  try {
    const response = await axios.post(
      `${API.BASE_URL}/api/admin/login`,
      { email, password },
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );
    
    if (response.data && response.data.success && response.data.token && response.data.admin) {
      // Store admin data with token
      const adminToStore = {
        ...response.data.admin,
        token: response.data.token
      };
      localStorage.setItem('adminToken', response.data.token);
      localStorage.setItem('admin', JSON.stringify(adminToStore));
    }
    
    return response.data;
  } catch (error) {
    console.error('Admin login error:', error);
    
    // Add fallback logic for 502 errors
    if (error.response && error.response.status === 502) {
      return {
        success: false,
        message: 'Server is temporarily unavailable. Please try again later.'
      };
    }
    
    throw error;
  }
};

// Logout admin
export const logoutAdmin = () => {
  localStorage.removeItem('adminToken');
  localStorage.removeItem('admin');
};

// Get admin profile
export const getAdminProfile = async () => {
  try {
    const response = await adminAxios.get('/api/admin/profile');
    return response.data;
  } catch (error) {
    console.error('Get admin profile error:', error);
    throw error;
  }
};

// Check if admin is authenticated
export const isAdminAuthenticated = () => {
  const token = localStorage.getItem('adminToken');
  const admin = localStorage.getItem('admin');
  return !!token && !!admin;
};

// Get current admin user from localStorage
export const getCurrentAdmin = () => {
  const adminStr = localStorage.getItem('admin');
  if (!adminStr) return null;
  
  try {
    return JSON.parse(adminStr);
  } catch (e) {
    console.error('Error parsing admin data:', e);
    return null;
  }
};

// Check if admin token is valid
export const verifyAdminToken = async () => {
  const token = localStorage.getItem('adminToken');
  if (!token) return false;
  
  try {
    const response = await axios.get(`${API.BASE_URL}/api/admin/verify-token`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    
    return response.data.success;
  } catch (error) {
    console.error('Token verification error:', error);
    return false;
  }
};

// Get Authorization headers for admin API requests
export const getAdminAuthHeader = () => {
  const token = localStorage.getItem('adminToken');
  if (token) {
    return { Authorization: `Bearer ${token}` };
  } else {
    return {};
  }
};

// Default export for backwards compatibility
export default {
  loginAdmin,
  logoutAdmin,
  getCurrentAdmin,
  verifyAdminToken,
  getAdminAuthHeader
};
